
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://etrspsphgbkapczqxboy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV0cnNwc3BoZ2JrYXBjenF4Ym95Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE2NDgyMTksImV4cCI6MjA1NzIyNDIxOX0.voSBoUIbZgDxl-1vCq5D53CC3-AiPFDFOqnPrhKMuC4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
